import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home/Home.vue'),
    },
    {
      path: '/boletin-financiero/:x?',
      name: 'boletin-financiero',
      component: () => import('@/views/Preview/Preview.vue'),
      meta: () => ({
        pageTitle: 'Boletín Financiero',
        breadcrumb: [
          {
            text: 'Inicio',
            to: '/',
          },
          {
            text: 'Información del boletín',
            active: true,
          },
        ],
      }),
    },
    {
      path: '/history',
      name: 'boletin-financiero-historico',
      component: () => import('@/views/Home/history/HistoryContent.vue'),
      meta: () => ({
        pageTitle: 'Boletín e-Financiero',
        breadcrumb: [
          {
            text: 'Inicio',
            to: '/',
          },
          {
            text: 'Boletín Financiero',
            to: '/boletin-financiero',
          },
          {
            text: 'Contenido histórico',
            active: true,
          },
        ],
      }),
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/Error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
